@import '../../../../constants/spacing.module.less';

.header {
  border-bottom: none;
  padding: @space-16;

  :global div.collapsible-list-caret > svg {
    fill: var(--default--icon--fill-color--3);
  }
}

.header-content {
  padding: @space-0;

  // height of the caret, this prevents the header from growing as the caret loads in
  min-height: 30px;
}

.sub-header {
  padding: @space-0 @space-16 @space-16;
}

.content {
  border-radius: unset;
  padding: @space-0 @space-16;
  color: var(--default--text-color--17);
}

.full-height {
  height: 100%;
}
